import Text from '../base/Text';

export default function BetaBadge({
  className,
  label = 'Beta',
}: {
  className?: string;
  label?: string;
}) {
  return (
    <Text
      as="span"
      variant="studio/body/medium/xs"
      className={`border border-transparent bg-gray-30 text-gray-45 transition-colors duration-150 dark:bg-gray-60 group-hover:bg-blue-60 group-hover:text-white group-data-highlighted:bg-blue-60 group-data-highlighted:text-white dark:group-hover:bg-blue-60 dark:group-hover:text-white dark:group-data-highlighted:bg-blue-60 dark:group-data-highlighted:text-white inline-flex shrink-0 select-none rounded-full px-2 py-0.5 ${
        typeof className === 'string' ? className : ''
      }`}
    >
      {label}
    </Text>
  );
}
